import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <g clipPath="url(#clip0_2038_1361)">
      <path
        fill={color}
        d="M12.5 12.417c1.519 0 5.09-1.828 5.09-6.209 0-.61-.014-1.2-.065-1.759-.082-1.097-.307-2.07-.867-2.815C15.94.619 14.684 0 12.5 0S9.06.62 8.342 1.633c-.56.746-.785 1.719-.867 2.817a20 20 0 0 0-.066 1.758c0 4.38 3.572 6.209 5.09 6.209M10.613 2.053a.633.633 0 0 1 1.143.068h1.488a.63.63 0 0 1 .586-.398c.232 0 .445.126.556.328a.04.04 0 0 1 0 .038.04.04 0 0 1-.033.019h-.565a.7.7 0 0 0-.028.248c0 .157.019.223.03.247h.564a.038.038 0 0 1 .033.056.634.634 0 0 1-1.143-.069h-1.488a.63.63 0 0 1-.587.399.63.63 0 0 1-.555-.328.038.038 0 0 1 .033-.057h.564a.7.7 0 0 0 .03-.248.7.7 0 0 0-.03-.247h-.565a.04.04 0 0 1-.033-.018.04.04 0 0 1 0-.038M8.167 5.26c.058.128.308.621.693.667.444.053 1.18-1.57 3.64-1.574 2.46.004 3.196 1.627 3.64 1.574.385-.046.634-.54.693-.667q.017.472.016.95c0 2.14-.945 3.467-1.738 4.203-1 .927-2.11 1.264-2.611 1.264s-1.612-.337-2.611-1.264C9.096 9.676 8.15 8.35 8.15 6.208q0-.477.017-.95"
      ></path>
      <path
        fill={color}
        d="M21.95 18.784c-.26-1.616-.794-3.698-1.867-4.438-.733-.505-3.29-1.87-4.38-2.453l-.02-.011a.36.36 0 0 0-.39.034 4.6 4.6 0 0 1-1.861.9.36.36 0 0 0-.256.221l-.676 1.781-.676-1.78a.36.36 0 0 0-.256-.223 4.6 4.6 0 0 1-1.862-.899.36.36 0 0 0-.389-.034c-1.079.577-3.667 1.97-4.397 2.462-1.235.833-1.775 3.845-1.87 4.44q-.015.09.015.176c.036.102.8 2.076 5.577 2.796a4.5 4.5 0 0 0 1.787 1.731 4.45 4.45 0 0 0 2.92.432 4.46 4.46 0 0 0 3.007-2.163c4.778-.72 5.542-2.694 5.578-2.796a.36.36 0 0 0 .017-.176m-5.65.989a3.814 3.814 0 0 1-3.072 3.523q-.359.07-.723.07c-.617 0-1.232-.15-1.779-.44a3.85 3.85 0 0 1-1.68-1.77 3.82 3.82 0 0 1-.237-2.523 3.815 3.815 0 0 1 4.815-2.707c.796.246 1.499.758 1.98 1.437.496.698.742 1.555.695 2.41"
      ></path>
      <path
        fill="#B5A5FA"
        d="M13.097 19.56c.355.071.71.177 1.04.324.321.142.608.343.906.525l.062.037a2.75 2.75 0 0 0 0-1.77c-.305.182-.595.39-.919.54-.345.16-.717.271-1.09.345"
      ></path>
      <path fill={color} d="M15.044 20.41c-.067-.04.035.021 0 0"></path>
      <path
        fill="#B5A5FA"
        d="M10.862 19.884a5 5 0 0 1 1.041-.323 4.8 4.8 0 0 1-1.106-.353c-.317-.15-.602-.353-.903-.532a2.75 2.75 0 0 0 0 1.77l.062-.037c.298-.182.586-.383.906-.525"
      ></path>
      <path fill={color} d="M9.956 20.41c-.035.021.066-.04 0 0"></path>
      <path
        fill="#B5A5FA"
        d="M13.006 16.856c.009.36.048.72.018 1.08-.032.39-.12.78-.246 1.15.259-.29.555-.558.878-.777.3-.203.634-.345.953-.514a2.75 2.75 0 0 0-1.603-.939M12.222 19.086a4.8 4.8 0 0 1-.247-1.15c-.03-.36.01-.72.02-1.08a2.75 2.75 0 0 0-1.605.939c.325.171.664.316.968.524.317.218.608.481.864.767M11.975 21.186c.033-.39.12-.78.247-1.15-.26.29-.556.558-.879.777-.3.203-.633.346-.953.515.402.479.964.819 1.604.938-.009-.36-.048-.72-.019-1.08M12.778 20.036c.126.37.214.76.247 1.15.03.36-.01.72-.02 1.08a2.75 2.75 0 0 0 1.604-.938c-.324-.172-.663-.316-.967-.525a5 5 0 0 1-.864-.767"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2038_1361">
        <path fill="#fff" d="M.5 0h24v24H.5z"></path>
      </clipPath>
    </defs>
  </svg>
  );
};
